import { OrderTemplateDto } from '@eurogast/hub-client-typescript';

export default class OrderTemplateSelectItem {
  public readonly templateName: string;
  public readonly templateId: number;
  public containsSku: boolean;


  constructor(template: OrderTemplateDto, productSku: string) {
    this.templateName = template.name;
    this.templateId = template.id;
    this.containsSku = template.orderTemplateItems.find((el) => el.productSku === productSku) != null;
  }
}
